import request from '@/utils/request'

// // 登录
// export function login(captcha,user,pwd) {
//   return request({
//     url: 'User/login',
//     method: 'post',
//     data: {
// 	  captcha,
//       user,
//       pwd
//     }
//   })
// }
// 登录
export function login(data) {
  return request({
    url: 'User/login',
    method: 'post',
    data: data
  })
}
// 修改密码
export function changePassword(data) {
  return request({
    url: '/Crm.Quote/changePassword',
    method: 'post',
    data: data
  })
}
// 用户资料
export function userDetails(params) {
  return request({
    url:'/Company.Employee/userDetails',
    method:'get',
    params:params
  })
}
// 修改用户资料
export function userDataModification(data) {
  return request({
    url: '/Company.Employee/userDataModification',
    method: 'post',
    data: data
  })
}
// 图片上传
// export function userDataModification(data) {
//   return request({
//     url: '/Base/upload',
//     method: 'post',
//     data: data
//   })
// }



// WEBPACK FOOTER //
// ./src/api/login.js